/**
 * Categories select / dropdown
 */

import { fetchAllCategories } from "@/services/collection/categories/categoriesApi";
import type { CategoryId } from "@/services/collection/categories/categoriesSchema";
import { gettext } from "@/services/translation";

/** @deprecated Use `undefined` to represent "all categories" instead. */
export const ValueAllCategories = 0;
/** @deprecated Use `undefined` to represent "all categories" instead. */
export type CategoriesAll = 0;
/** @deprecated Use `CategoryId | undefined` instead. */
export type CategoryIdOrAll = CategoryId | CategoriesAll;
export type SelectValue = undefined | typeof ValueAllCategories | number;

export type Option = {
  label: string;
  value: Exclude<SelectValue, undefined>;
};

export async function createOptions(addOptionAll = false): Promise<Option[]> {
  return fetchAllCategories().then((categories) => {
    const options: Option[] = categories.map((category) => ({
      label: category.name,
      value: category.id,
    }));

    if (addOptionAll) {
      const optionAll = {
        label: gettext.$gettext("Všechny kategorie"),
        value: ValueAllCategories,
      };
      options.unshift(optionAll);
    }

    return options;
  });
}
